/**
 * A meter's fill — how full a used/ceiling pair is (2 of 4 channel units, 38% of a build).
 *
 * Moved from the portal's `apps/web-app/src/meter.ts` (plan-034 VIEW-PKG). The portal turns the percentage into its CSS
 * custom property (`meterStyle`, which stays there because it is a React style object); the app turns it into a width.
 */
/** `2 of 4` as a percentage, with a zero ceiling treated as empty rather than as a crash. */
export function meterPercent(inUse, ceiling) {
    if (ceiling <= 0)
        return 0;
    return (inUse / ceiling) * 100;
}
/** Whole and clamped to 0–100, so a server that reports 118% does not draw a bar out of its track. */
export function meterFillPercent(percent) {
    return Math.max(0, Math.min(100, Math.round(percent)));
}
//# sourceMappingURL=meter.js.map